define('plugin/invoice/view/InvoicePaymentMethodListView',['require','lib/view/CompositeView','plugin/invoice/view/InvoicePaymentMethodListItemView'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var InvoicePaymentMethodListItemView = require('plugin/invoice/view/InvoicePaymentMethodListItemView');

    /**
     * Invoice payment system view
     *
     * @class InvoicePaymentSystemView
     */
    return CompositeView.extend({

        template: '#invoice_payment_method_list_view',
        childView: InvoicePaymentMethodListItemView,
        childViewContainer: '#sb_invoice_payment_methods_container',

        collectionEvents: {
            'sync': '_onSync'
        },
        childEvents: {
            'payment_method:delete': 'triggerPaymentMethodDelete'
        },

        _onSync: function() {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        triggerPaymentMethodDelete: function (view, data) {
            this.triggerMethod('payment_method:delete', data.model);
        }

    });

});
